import { useTranslation } from 'react-i18next'

import { cn } from '@/lib/utils'

/**
 * Die Bildmarke: orange Kachel mit einer Raeubermaske.
 *
 * Gezeichnet statt als Bilddatei, wie im abgenommenen Clickdummy
 * (`BrandMark` in `clickdummy/app-source.html`). Die Marke bleibt damit in
 * jeder Groesse scharf und zieht ihr Orange aus dem Design-Token.
 *
 * Spiegelt bewusst die gleichnamige Komponente der laravel-app: Die beiden
 * Anwendungen teilen keinen Code, nur die Tokens - siehe wb-theme.css.
 */
export function BrandMark({ size = 36, className }: { size?: number; className?: string }) {
    const { t } = useTranslation()

    return (
        <div
            role="img"
            aria-label={t('brand.gluexxit')}
            className={cn(
                'flex flex-none items-center justify-center rounded-[10px]',
                'bg-linear-135 from-wb-accent to-wb-accent/65',
                'shadow-[0_4px_12px_var(--color-wb-accent)]/30',
                className,
            )}
            style={{ width: size, height: size }}
        >
            <svg
                width={size * 0.6}
                height={size * 0.6}
                viewBox="0 0 24 24"
                aria-hidden="true"
                focusable="false"
            >
                <path
                    d="M3 9 L21 9 L21 14 Q21 17 18 17 L15 17 Q13.5 17 13 15.5 L12 14 L11 15.5 Q10.5 17 9 17 L6 17 Q3 17 3 14 Z"
                    fill="#0a0d14"
                />
                <circle cx="8" cy="13" r="1.5" fill="#fff" />
                <circle cx="16" cy="13" r="1.5" fill="#fff" />
            </svg>
        </div>
    )
}
